import actionTypes from '../constants/action-types';

const setBlockHTML = (blockId, html, locale) => ({
  type: actionTypes.SET_BLOCK_HTML,
  payload: {
    blockId,
    html,
    locale,
  },
});

export default setBlockHTML;
